module.exports = __webpack_public_path__ + "img/icon-verified green.c8336085.svg";